export default function FooterElement () {
    return(
        <div>
<footer>
    <div className="footer-info">
        <div className="footer-text-logo">
            <img src="../img/mb-text-logo-master.png" alt="morrisville borough script logo"/>
        </div>
    </div>
    <div className="footer-info-row">
        <div className="footer-address">
            <b>Borough Hall</b><br/>
            <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8" className="no-underline">
                <i className="fa-solid fa-location-pin"></i>&nbsp;35 Union Street<br/>Morrisville, PA 19067</a>
        </div>
        <div className="footer-address">
            <b>Hall Hours:</b><br/>
            Monday-Friday<br/>8:00 a.m. to 4:30 p.m.
        </div>
        <div className="footer-contact">
            <b>Contact</b><br/>
            <a href="tel:2152958181" className="no-underline"><i className="fa-solid fa-phone"></i>&nbsp;215-295-8181</a><br/>
            <a href="tel:2157363760" className="no-underline"><i className="fa-solid fa-fax"></i>&nbsp;215-736-3760<br/></a>
            <a href="mailto:info@morrisvilleboro.org" className="no-underline"><i className="fa-solid fa-envelope"></i>&nbsp;info@morrisvilleboro.org<br/></a>
        </div>
        <div className="footer-socials">
            <b>Socials</b><br/>
            <a href="https://www.facebook.com/boroughofmorrisvillepa/" className="no-underline">
                <i className="fa-brands fa-square-facebook"></i>&nbsp;Borough Facebook</a>
            <br/>
            <a href="https://www.facebook.com/people/Morrisville-Borough-Police-Department/100064518469141/" className="no-underline">
                <i className="fa-brands fa-square-facebook"></i>&nbsp;Police Facebook</a>

        </div>
        <div className="footer-sitetools">
            <b>Site Tools</b><br/>
            <a href="/sitemap" className="no-underline">Site Map</a>
            <br/>
            <a href="/privacy" className="no-underline">Privacy Policy</a>

        </div>
    </div>
</footer>

        </div>
        )
        }